import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const ArrowUpRightIcon = ({ size = 14, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 17L17 7M8 7h9v9" />
  </svg>
)
